/* GUTTER TM base behaviour. Event delegation on data-act, exactly like the prototype app.js.
   Handles: sheet (mobile menu), closeSheet, fold (collapsible rows), peek (index row hover preview).
   Cart and product behaviour live in cart.js and product.js, never here.
   Public: window.GUTTER.sheet(open), window.GUTTER.peek(on, src, alt, x, y). */
(function (w, d) {
  "use strict";

  function el(sel, root) { return (root || d).querySelector(sel); }

  /* Mobile menu sheet. Markup: #sheet.sheet[aria-hidden], burger [data-act="sheet"][aria-expanded]. */
  function sheet(on) {
    var s = el("#sheet");
    if (!s) return;
    if (typeof on !== "boolean") on = !s.classList.contains("is-on");
    s.classList.toggle("is-on", on);
    s.setAttribute("aria-hidden", on ? "false" : "true");
    d.documentElement.classList.toggle("is-sheet", on);
    var burgers = d.querySelectorAll('[data-act="sheet"]');
    for (var i = 0; i < burgers.length; i++) burgers[i].setAttribute("aria-expanded", on ? "true" : "false");
    if (on) {
      var first = s.querySelector("a, button");
      if (first) first.focus();
    } else if (s.contains(d.activeElement) && burgers.length) {
      burgers[0].focus();
    }
  }

  /* Collapsible row. Markup: .fold > .fold__btn[data-act="fold"] > .fold__sign, then .fold__body. */
  function fold(btn) {
    var f = btn.closest(".fold");
    if (!f) return;
    var open = f.classList.toggle("is-open");
    btn.setAttribute("aria-expanded", open ? "true" : "false");
    var sign = el(".fold__sign", f);
    if (sign) sign.textContent = open ? "−" : "+";
  }

  /* Index peek. Any element with data-peek="<image url>" (and optional data-peek-alt) shows
     the image in #peek next to the cursor while hovered. Desktop only (the css hides .peek below 901px). */
  var peekSrc = "";
  function peek(on, src, alt, x, y) {
    var p = el("#peek");
    if (!p) return;
    if (!on) { p.classList.remove("is-on"); return; }
    if (!src) return;
    if (peekSrc !== src) {
      p.textContent = "";
      var img = d.createElement("img");
      img.className = "ph";
      img.src = src;
      img.alt = alt || "";
      img.draggable = false;
      p.appendChild(img);
      peekSrc = src;
    }
    /* Never cover the row under the cursor: below and to the right, else above or left. */
    var pw = 190, ph = 190;
    var left = x + 30, top = y + 26;
    if (left + pw > w.innerWidth - 12) left = x - pw - 30;
    if (top + ph > w.innerHeight - 12) top = y - ph - 26;
    top = Math.max(56, top);
    p.style.left = left + "px";
    p.style.top = top + "px";
    p.classList.add("is-on");
  }

  function onClick(e) {
    var node = e.target.closest ? e.target.closest("[data-act]") : null;
    if (!node) return;
    var act = node.dataset.act;
    if (act === "sheet") { sheet(); return; }
    if (act === "closeSheet") { sheet(false); if (node.tagName === "A") e.preventDefault(); return; }
    if (act === "fold") { fold(node); return; }
  }

  function onMove(e) {
    if (!el("#peek")) return;
    var row = e.target.closest ? e.target.closest("[data-peek]") : null;
    if (row) peek(true, row.getAttribute("data-peek"), row.getAttribute("data-peek-alt"), e.clientX, e.clientY);
    else peek(false);
  }

  function onKey(e) {
    if (e.key === "Escape") sheet(false);
  }

  function boot() {
    d.addEventListener("click", onClick);
    d.addEventListener("mousemove", onMove);
    d.addEventListener("keydown", onKey);
    var m = w.matchMedia ? w.matchMedia("(min-width: 901px)") : null;
    if (m && m.addEventListener) m.addEventListener("change", function (ev) { if (ev.matches) sheet(false); });
  }

  w.GUTTER = w.GUTTER || {};
  w.GUTTER.sheet = sheet;
  w.GUTTER.peek = peek;

  if (d.readyState === "loading") d.addEventListener("DOMContentLoaded", boot); else boot();
})(window, document);
